import React, { useEffect, useState, useContext, useCallback } from 'react'
import { Grid, Paper, Typography } from '@material-ui/core'
import { secondsToStringTimer } from '../../../../utils/Formatter'
import { makeStyles } from '@material-ui/core/styles'
import { AuthContext } from 'elentari'
import useQueryFilter from '../../useQueryFilter'
import tarefaSlaRepository from '../../TarefaSlaRepository'

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(2)
  }
}))

function useFetchTempos(props) {
  const { params, query } = props
  const geral = params?.geral
  const [temposFilaAtual, setTemposFilaAtual] = useState({})
  const [temposAnaliseAtual, setTemposAnaliseAtual] = useState({})

  const memoFetchData = useCallback(async () => {
    const [responseFila, responseAnalise] = await Promise.all([
      tarefaSlaRepository.temposFilaAtual({
        geral,
        empresaId: query.empresaId
      }),
      tarefaSlaRepository.temposAnaliseAtual({
        geral,
        empresaId: query.empresaId
      })
    ])
    if (responseFila.ok)
      setTemposFilaAtual({
        medio: secondsToStringTimer(responseFila.data.tempomedio),
        maximo: secondsToStringTimer(responseFila.data.tempomaximo)
      })
    if (responseAnalise.ok)
      setTemposAnaliseAtual({
        medio: secondsToStringTimer(responseAnalise.data.tempomedio),
        maximo: secondsToStringTimer(responseAnalise.data.tempomaximo)
      })
  }, [geral, query])

  useEffect(() => {
    memoFetchData()
    const interval = setInterval(memoFetchData, 1000 * 30)
    return () => clearInterval(interval)
  }, [memoFetchData])

  return [temposFilaAtual, temposAnaliseAtual]
}

const CardsTempo = props => {
  const classes = useStyles()
  const { user } = useContext(AuthContext)
  const [query] = useQueryFilter(props.location.search)
  const isGestor = user.realm === 'gestor'
  const [temposFilaAtual, temposAnaliseAtual] = useFetchTempos({ query })
  const [temposFilaAtualGeral, temposAnaliseAtualGeral] = useFetchTempos({
    query,
    params: { geral: true }
  })

  return (
    <>
      <Grid item xs={12}>
        <Paper className={classes.card}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} lg={3}>
              <Typography gutterBottom>Tempo médio na fila</Typography>
              <Typography variant="h5">{temposFilaAtual.medio}</Typography>
              {isGestor && (
                <Typography variant="subtitle2" color="textSecondary">
                  {temposFilaAtualGeral.medio} para todos centros de custo
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <Typography gutterBottom>Tempo máximo na fila</Typography>
              <Typography variant="h5">{temposFilaAtual.maximo}</Typography>
              {isGestor && (
                <Typography variant="subtitle2" color="textSecondary">
                  {temposFilaAtualGeral.maximo} para todos centros de custo
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <Typography gutterBottom>Tempo médio na análise</Typography>
              <Typography variant="h5">{temposAnaliseAtual.medio}</Typography>
              {isGestor && (
                <Typography variant="subtitle2" color="textSecondary">
                  {temposAnaliseAtualGeral.medio} para todos centros de custo
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <Typography gutterBottom>Tempo máximo na análise</Typography>
              <Typography variant="h5">{temposAnaliseAtual.maximo}</Typography>
              {isGestor && (
                <Typography variant="subtitle2" color="textSecondary">
                  {temposAnaliseAtualGeral.maximo} para todos centros de custo
                </Typography>
              )}
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  )
}

export default React.memo(CardsTempo)
